'use client'

import { ReactNode, useEffect, useRef, useState } from 'react'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

type Props = {
  children: ReactNode
}

const AdvertisementWrapper = ({ children }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const breakpoints = useBreakpoint()

  const isWrapperEnabled = useFeatureSwitch('advertisement_wrapper_enabled')
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!isWrapperEnabled) {
      setIsVisible(true)

      return
    }

    if (!ref.current) return

    setIsVisible(ref.current.checkVisibility())
  }, [isWrapperEnabled, breakpoints])

  return <div ref={ref}>{isVisible && children}</div>
}

export default AdvertisementWrapper
